import React from 'react';
import { Link } from 'react-router-dom';
import './Page.css';
import usePageTitle from '../hooks/usePageTitle';

const lodges = [
  {
    number: 106,
    name: 'Ivy Lodge No. 106',
    location: 'Williamsport',
    meeting: '1st Monday at 7:30 PM',
    url: 'https://www.ivylodge106.org/',
    type: 'website',
  },
  {
    number: 199,
    name: 'Lafayette Lodge No. 199',
    location: 'Lock Haven',
    meeting: '2nd Thursday at 7:30 PM',
    url: 'https://lafayettelodge199.com/',
    type: 'website',
  },
  {
    number: 232,
    name: 'La Belle Valle Lodge No. 232',
    location: 'Jersey Shore',
    meeting: '1st Tuesday at 7:30 PM',
    url: 'http://www.palodge232.org/',
    type: 'website',
  },
  {
    number: 299,
    name: 'Muncy Lodge No. 299',
    location: 'Muncy',
    meeting: '1st Thursday at 7:30 PM',
    url: '/',
    type: 'home',
  },
  {
    number: 335,
    name: 'Eureka Lodge No. 335',
    location: 'Montoursville',
    meeting: '2nd Thursday at 7:30 PM',
    url: 'https://www.facebook.com/p/Eureka-Lodge-335-FAM-100069316447389/',
    type: 'facebook',
  },
  {
    number: 401,
    name: 'Watsontown Lodge No. 401',
    location: 'Watsontown',
    meeting: '1st Tuesday at 7:30 PM',
    url: 'https://www.facebook.com/p/Watsontown-Masonic-Lodge-401-100077471832808/',
    type: 'facebook',
  },
  {
    number: 707,
    name: 'John F. Laedlein Lodge No. 707',
    location: 'South Williamsport',
    meeting: '2nd Monday at 7:30 PM',
    url: 'https://www.facebook.com/profile.php?id=100076607020373',
    type: 'facebook',
  },
  {
    number: 755,
    name: 'Dietrick Lamade Lodge No. 755',
    location: 'Williamsport',
    meeting: '3rd Monday at 7:30 PM',
    url: 'https://www.facebook.com/p/Dietrick-Lamade-Lodge-755-FAM-61566476188537/',
    type: 'facebook',
  },
];

function District() {
  usePageTitle('18th Masonic District');

  return (
    <div className="page-container">
      <div className="page-hero calendar-hero" style={{ backgroundImage: 'url(/squareandcompasses2.jpg)' }}>
        <h1>18th Masonic District</h1>
        <p>Stated Meeting Schedule &amp; Lodge Directory</p>
      </div>

      <div className="page-content">
        <section className="content-section">
          <h2>District Lodges</h2>
          <p>The 18th Masonic District of the Grand Lodge of Pennsylvania is home to eight lodges across Lycoming, Clinton, and surrounding counties. Below is the stated meeting schedule for each lodge.</p>

          <div className="district-grid">
            {lodges.map((lodge) => (
              <div key={lodge.number} className={`district-card${lodge.number === 299 ? ' district-card-highlight' : ''}`}>
                <h3>{lodge.name}</h3>
                <p className="district-location">{lodge.location}</p>
                <p className="district-meeting">{lodge.meeting}</p>
                {lodge.type === 'home' ? (
                  <Link to={lodge.url} className="district-link">
                    Visit Our Site
                  </Link>
                ) : (
                  <a href={lodge.url} target="_blank" rel="noopener noreferrer" className="district-link">
                    {lodge.type === 'facebook' ? 'Visit Facebook' : 'Visit Website'}
                  </a>
                )}
              </div>
            ))}
          </div>

          <p style={{ marginTop: '2rem', color: '#666', fontStyle: 'italic' }}>Dinners are normally held immediately prior to the meetings (approx. 6:15–6:30 PM) and are typically open to family members. Please contact individual lodges for specific details.</p>
        </section>

        <section className="content-section" style={{ textAlign: 'center' }}>
          <p>
            <Link to="/calendar" className="district-back-link">&larr; Back to Lodge Calendar</Link>
          </p>
        </section>
      </div>
    </div>
  );
}

export default District;
